var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "tw-bg-[#F6C46A] tw-shadow tw-rounded tw-p-4 tw-flex tw-flex-col md:tw-flex-row tw-justify-between tw-items-center tw-gap-4"
  }, [_c('div', {
    staticClass: "tw-flex tw-items-center tw-gap-4"
  }, [_c('i', {
    staticClass: "airalo-icon-warning tw-text-[40px]"
  }), _vm._v(" "), _c('span', {
    staticClass: "tw-text-[14px]/[20px] tw-font-semibold tw-flex tw-items-center tw-whitespace-pre-line",
    domProps: {
      "textContent": _vm._s(_vm.message)
    }
  })]), _vm._v(" "), _vm.actionText ? [_c('button', {
    class: ['tw-w-full md:tw-max-w-[167.5px]', 'tw-flex tw-justify-center tw-items-center', 'tw-bg-transparent tw-text-primary tw-text-10 tw-font-bold tw-tracking-widest', 'tw-border tw-border-solid tw-border-primary', 'tw-rounded', 'tw-py-2 tw-px-2.5', 'tw-transition tw-duration-300 tw-ease-in-out', 'hover:tw-bg-primary hover:tw-text-white'],
    attrs: {
      "type": "button"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('click');
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.actionText) + "\n    ")])] : _vm._e()], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }